import React, { useEffect, useState } from 'react';

import { useMedia } from 'react-use';
import { showToast } from '../../shared/Toast';
import {
  fromRole,
  getSbStatusColorString,
  getSbStatusStringWithCounts,
  getStorageNotification,
  isExpired,
  ProjectModel,
  saveStorageNotification,
  SbCurrentUser,
  SbRecipientModel,
  SbStatusMaster,
  SubmissionBoardModel,
} from '../component/SbModel';
import submissionBoardService from '../../services/SubmissionBoardService';
import SbDetailsListItem from '../creator/SbDetailsListItem';
import { CheckIcon, Star, InfoIcon, XIcon } from 'lucide-react';
export interface SbDetailsRecipientProps {
  currentUser: SbCurrentUser;
  sb_recipient: SbRecipientModel;
  project: ProjectModel;
  submissionBoardModel: SubmissionBoardModel;
  fromPage: string;
}
// for recipient : director
// For SB details for recipient, we dont show all parameters like SbDetails.
// from SB controller: show method
export default function SbDetailsRecipient({
  currentUser,
  sb_recipient,
  project,
  submissionBoardModel,
  fromPage,
}: SbDetailsRecipientProps) {
  const [records, setRecords] = useState<SubmissionBoardModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  // const [profiles, setProfiles] = useState([]);
  // const [showProfileDetails, setShowProfileDetails] = useState(null);
  // const [currentProfileIndex, setCurrentProfileIndex] = useState(null);
  const [isSbClosed, setIsSbClosed] = useState(false);
  const [showGuideCard, setShowGuideCard] = useState(
    getStorageNotification('sb_external') == 1 ? true : false
  );
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [noMoreData, setNoMoreData] = useState<string>('');

  useEffect(() => {
    // fetchProfilesForSB();
    fetchSubmissionBoardAllDetails(submissionBoardModel.id);
  }, [submissionBoardModel]);

  const fetchSubmissionBoardAllDetails = async (sb_id: number) => {
    try {
      setIsLoading(true);
      console.log('sb: fetchSubmissionBoards In');
      const submission_board_resp = await submissionBoardService.getSubmissionBoard(
        project.uuid,
        sb_id,
        sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : '',
        sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : ''
      );
      if (submission_board_resp) {
        if (
          submission_board_resp.sb_status == SbStatusMaster.expired ||
          submission_board_resp.sb_status == SbStatusMaster.locked
        ) {
          setIsSbClosed(true);
        } else {
          setIsSbClosed(false);
        }
        setRecords([submission_board_resp]);
        setOpenIndex(0);
        setSelectedSubmissionBoard(submission_board_resp);
      }
    } catch (error) {
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
      console.log('sb: fetchSubmissionBoards Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };
  const togglePanel = (index: number) => {
    // If the clicked panel is already open, close it. Otherwise, open the new one.
    if (fromPage !== fromRole.SB_EXTERNAL_RECIPIENT) {
      setOpenIndex(openIndex === index ? null : index);
    }
  };
  // const fetchProfilesForSB = async () => {
  //   try {
  //     const profiles = await submissionBoardService.getSBPerformers(
  //       project.uuid,
  //       submissionBoardModel.id,
  //       sb_recipient && sb_recipient.key_token ? sb_recipient.key_token : undefined,
  //       sb_recipient && sb_recipient.otp_valid ? sb_recipient.otp_valid : undefined,
  //       true
  //     );
  //     setProfiles(profiles);
  //   } catch (error) {
  //     showToast('Error while fetching submission boards.', 'danger');
  //   } finally {
  //   }
  // };
  // const refreshClicked = async (event: React.MouseEvent) => {
  //   fetchProfilesForSB();
  // };

  return (
    <div className="w-full flex flex-1 mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-10">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex w-full items-center justify-between">
          <div className="flex flex-row gap-1 items-center">
            <span className="text-3xl leading-9 font-medium text-gray-900">Submission Board</span>
            {!showGuideCard && (
              <div
                className="flex w-4-2 h-4-2 text-blue-600 hover:text-blue-800 cursor-pointer transition-colors duration-200"
                onClick={() => {
                  setShowGuideCard(true);
                  saveStorageNotification('sb_external', 1);
                }}
              >
                <InfoIcon className="w-4-2 h-4-2" strokeWidth={2} />
              </div>
            )}
          </div>
        </div>
        <hr className="mt-4 mb-4" />
        <div className="flex flex-col relative w-full">
          {/* Guide Card */}
          {showGuideCard && (
            <div className="w-full p-5 bg-blue-100 text-blue-800 font-semibold rounded-lg relative gap-4 flex flex-col">
              {/* Close Button */}
              <div
                className="absolute  top-2 right-2 cursor-pointer  w-5 h-5  flex items-center justify-center"
                onClick={() => {
                  setShowGuideCard(false);
                  saveStorageNotification('sb_external', 0);
                }}
              >
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </div>
              <div className="text-base font-semibold">Performer submissions for your review</div>
              <div className="flex flex-col space-y-2 pl-1 gap-4 text-base font-normal">
                <div className="flex items-top gap-3 ">
                  <div className="h-6 w-5 px-1 flex items-center justify-center">
                    <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                      •
                    </div>
                  </div>
                  <div className="m-0" style={{ margin: 0 }}>
                    <span className="font-medium">Review Performers:</span> View photos, reels, and/or self-tapes to assess for the role.
                  </div>
                </div>
                <div className="flex items-top gap-3 ">
                  <div className="h-6 w-5 px-1 flex items-center justify-center">
                    <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                      •
                    </div>
                  </div>
                  <div className="m-0" style={{ margin: 0 }}>
                    <span className="font-medium">Stars & Notes:</span> Use stars and notes to share preferences or context with your team (optional).
                  </div>
                </div>
                <div className="flex items-top gap-3 ">
                  <div className="h-6 w-5 px-1 flex items-center justify-center">
                    <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                      •
                    </div>
                  </div>
                  <div className="m-0" style={{ margin: 0 }}>
                    <span className="font-medium">Final Selection:</span> At least one performer must be selected unless multiple selections required
                  </div>
                </div>
                <div className="flex items-top gap-3 ">
                  <div className="h-6 w-5 px-1 flex items-center justify-center">
                    <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                      •
                    </div>
                  </div>
                  <div className="m-0" style={{ margin: 0 }}>
                    Any member of your selection team may confirm the final choice when ready.
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="scrollable-content overflow-y-auto mt-1 justify-items-center ">
            <div className="flex w-full flex-col py-2">
              {/* <%# SB start %> */}
              <div
                id="sb_list_id"
                // ref={listRef}
                className={(is400_639Screen ? 'px-0' : 'p-0') + ' flex w-full flex-col  gap-6'}
              >
                {records.map((item, index) => {
                  const isOpen = openIndex === index;
                  const contentId = `accordion-content-${index}`;
                  const headerId = `accordion-header-${index}`;

                  return (
                    <div
                      key={index}
                      className={`border rounded-md ${
                        isOpen ? 'border-gray-200 ' : 'border-gray-200'
                      }
                            `}
                    >
                      {/* accordian title bar start */}
                      <button
                        id={headerId}
                        type="button"
                        className={`flex rounded-md justify-between items-center w-full py-3 px-6 font-semibold text-left transition-colors duration-200
                              ${isOpen ? 'bg-white shadow-sm ' : 'bg-white shadow-sm '}
                              `}
                        onClick={async () => {
                          if (fromPage !== fromRole.SB_EXTERNAL_RECIPIENT) {
                            if (openIndex === index) {
                              // closing
                              togglePanel(index);
                              setSelectedSubmissionBoard(null);
                              return;
                            }
                            togglePanel(index);
                            setSelectedSubmissionBoard(null);
                            await fetchSubmissionBoardAllDetails(item.id);
                          }
                        }}
                        aria-expanded={isOpen}
                        aria-controls={contentId}
                      >
                        <div className="flex items-center gap-2">
                          <img
                            className="rounded-lg w-9 h-9"
                            src={project.project_image_thumb}
                          ></img>
                          {(item.header ? item.header + ' / ' : '') + item.title}
                        </div>

                        <div className="flex items-center gap-2">
                          <div
                            style={{ lineHeight: '100%', height: '1.65rem' }}
                            className={
                              'font-medium text-sm h-7 flex items-center chip ' +
                              getSbStatusColorString(
                                isExpired(item.expire_at) ? 'expired' : item.sb_status
                              )
                            }
                          >
                            {getSbStatusStringWithCounts(item)}
                          </div>
                          <svg
                            className={`
                              w-4 h-4 transform transition-transform duration-200
                              ${isOpen ? 'rotate-180' : 'rotate-0'}
                            `}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            ></path>
                          </svg>
                        </div>
                      </button>
                      {/* accordian title bar end */}
                      {/* accordian title body start */}
                      {/* {index == 0 && <div
                                className={`
                              transition-all duration-300 ease-in-out
                              max-h opacity-100 pb-4 bg-white`}><PreferredByRecipentDummy /></div>} */}
                      {openIndex != null && openIndex === index && (
                        <div
                          id={contentId}
                          role="region"
                          aria-labelledby={headerId}
                          className={`
                                transition-all duration-300 ease-in-out
                                ${isOpen ? 'max-h opacity-100 pb-4 bg-white' : 'max-h-0 opacity-0'}
                              `}
                        >
                          {selectedSubmissionBoard != null && (
                            <div>
                              <SbDetailsListItem
                                fromScreen={fromPage}
                                indexRow={index}
                                currentUser={currentUser}
                                project={project}
                                sb_recipient={sb_recipient}
                                submissionBoardModel={selectedSubmissionBoard}
                                dialogCloseHandler={() => {
                                  // setSelectedSubmissionBoard(null);
                                }}
                                refreshSubmissionBoard={() => {
                                  fetchSubmissionBoardAllDetails(selectedSubmissionBoard.id);
                                }}
                                updateSubmissionBoardCounts={() => {}}
                                editSb={function (index: number): void {}}
                              ></SbDetailsListItem>
                            </div>
                          )}
                        </div>
                      )}
                      {/* accordian title body end */}
                    </div>
                  );
                })}
              </div>
              {/* <%# SB end %> */}
            </div>
            <div className="w-full py-2 flex flex-col justify-center">
              {isLoading && (
                <div className="justify-center items-center flex w-full ">
                  <div className="text-center font-bold text-xl">Loading...</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
